import React, { useState, useEffect, useContext } from 'react';
import moment from 'moment';

// Prime React
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

// Icons
import ViewEye from '../../../../../svgs/Document/ViewEye';

// Paginator
import { PaginatorTemplate } from '../../../../../ui/PaginatorTemplate/PaginatorTemplate';
import { fetchProspectDocuments, getDocumentsCount } from '../../../../../services/documents';

// Context
import { ToastContext } from '../../../../../context/toast';
import { classNames } from 'primereact/utils';
import { useParams } from 'react-router-dom';
import CustomLoading from '../../../../../ui/CustomSpinner/custom_spinner';
import { DATE_TIME_FORMAT } from '../../../../../utils/Constants/global';
import { openAttachment } from '../../../../../utils/HelperFuctions/openAttachment';
import { dateFormatForInputFields } from '../../../../../utils/HelperFuctions/dateFormat';

const Body = (props) => {

    const { id } = useParams();

    // Context
    const toast = useContext(ToastContext);

    // View State

    const { activeIndex, activeTabData, keyword, selectedDateFilter, dates2, loading, setLoading, setClientName } = props
    const [gridData, setGridData] = useState([]);
    const [selectedTabHeaders, setSelectedTabHeaders] = useState([]);
    const [openAttachmentLoading, setOpenAttachmentLoading] = useState(false);
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);
    const [sortCount, setSortCount] = useState(0);

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [page, setPage] = useState(currentPage);
    const [pageSize, setPageSize] = useState(10);
    const [pagination, setPagination] = useState({
        totalRecords: 0,
        isFirstPage: 1,
        isLastPage: 0,
        totalPages: 0,
    });

    const [pageInputTooltip, setPageInputTooltip] = useState("Press 'Enter' key to go to this page.");

    const handleShowAttachment = async (file) => {
        try {
            setOpenAttachmentLoading(true);
            await openAttachment(file);
        } catch (error) {
            console.error("Error opening attachment:", error);
        } finally {
            setOpenAttachmentLoading(false);
        }
    };

    const headerDataBdoy = (colField) => (rowData) => {
        if (colField === "preview") {
            return (
                <>
                    <div >
                        <span onClick={() => handleShowAttachment(rowData.attachment_path)} >
                            <ViewEye />
                        </span>
                    </div>
                </>
            );
        } else if (colField === "updated_at") {
            return <>
                <div>
                    {moment(rowData[colField]).format(DATE_TIME_FORMAT)}
                </div>
            </>
        } else if (colField === "uploaded_by") {
            return <>
                <div>
                    {rowData[colField] !== " " ? rowData[colField] : "-"}
                </div>
            </>
        } else {
            return rowData[colField] ? rowData[colField] : "";
        }
    };

    // Grid Sorting
    const onSort = (e) => {
        if (e.sortField === sortField) {
            if (sortCount === 1) {
                setSortCount(0);
                setSortField(null);
                setSortOrder(null);
            } else {
                setSortCount(sortCount + 1);
                setSortField(e.sortField);
                setSortOrder(e.sortOrder);
            }
        } else {
            setSortField(e.sortField);
            setSortOrder(e.sortOrder);
        }
    };

    const renderSortIcon = (field) => {
        if (sortField === field) {
            return (
                <i
                    className={classNames("pi pi-fw", {
                        "pi-sort-alt": sortOrder === null,
                        "pi-sort-asc": sortOrder === 1,
                        "pi-sort-desc": sortOrder === -1,
                    })}
                />
            );
        }
        return null;
    };

    const columnComponents = selectedTabHeaders.map((col) => {
        if (col?.field === "preview") {
            return (
                <Column key={col.field} field={col.field} header={col.header} body={headerDataBdoy(col.field)} />
            );
        }
        else if (col?.field === "updated_at") {
            return (
                <Column key={col.field} field={col.field} header={col.header} body={headerDataBdoy(col.field)} >
                </Column>
            )
        }
        else if (col?.field === "attachment_name") {
            return (
                <Column key={col.field} field={col.field} header={col.header} body={headerDataBdoy(col.field)} sortable>
                    {renderSortIcon(col.field)}
                </Column>
            )
        }
        else if (col?.field === "attachment_type") {
            return (
                <Column key={col.field} field={col.field} header={col.header} body={headerDataBdoy(col.field)} sortable>
                    {renderSortIcon(col.field)}
                </Column>
            )
        }
        else {
            return <Column key={col.field} field={col.field} header={col.header} body={headerDataBdoy(col.field)} />;
        }
    });


    // Api Handler
    const getDocuments = async () => {
        try {
            let type = 'prospect';

            if (activeIndex === 0) {
                type = 'prospect';
            } else if (activeIndex === 1) {
                type = 'invoice';
            } else if (activeIndex === 2) {
                type = 'collection';
            }

            let payload = {
                prospect_id: parseInt(id),
                type: type,
                date_keyword: selectedDateFilter === "dateRange"
                    ? (dates2?.[0] && dates2?.[1]
                        ? `${dateFormatForInputFields(dates2[0])},${dateFormatForInputFields(dates2[1])}`
                        : null)
                    : selectedDateFilter,
                per_page: pageSize,
                search_text: keyword === null ? "" : keyword,
                page: page ? page : currentPage,
            };
            if (sortField) {
                payload["sort_by"] = sortField;
            }
            if (sortOrder) {
                payload["sort_desc"] = sortOrder === 1 ? "asc" : "desc";
            }

            if (selectedDateFilter !== "dateRange" || (payload["date_keyword"] != null && payload["date_keyword"][0] != null && payload["date_keyword"][1] != null)) {
                setLoading(true);
                const res = await fetchProspectDocuments(payload);
                if (res) {
                    if (res?.data?.prospect_attachments) {
                        setGridData(res?.data?.prospect_attachments?.data);
                        setPagination({
                            ...pagination,
                            totalRecords: res?.data?.prospect_attachments?.total,
                            totalPages: res?.data?.prospect_attachments?.last_page,
                            isLastPage: res?.data?.prospect_attachments?.last_page,
                        });
                        setLoading(false);
                    }

                    if (res?.data?.company_business_name) {
                        setClientName(res?.data?.company_business_name);
                    }

                } else {
                    toast.showMessage("Error", "Server error.", "error");
                    setLoading(false);
                }
            }
        } catch (error) {
            toast.showMessage("Error", "Server error.", "error");
            setLoading(false);
        }
    };

    // //UseEffect

    useEffect(() => {
        getDocuments();
    }, [sortField, sortOrder, pageSize, currentPage, activeIndex, selectedDateFilter, dates2]);


    useEffect(() => {
        if (activeTabData.underWritingTab.activeTabIndex === activeIndex) {
            setSelectedTabHeaders(activeTabData.underWritingTab.underWrittingHeaders);
        } else if (activeTabData.invoicesTab.activeTabIndex === activeIndex) {
            setSelectedTabHeaders(activeTabData.invoicesTab.invoicesHeaders)
        } else if (activeTabData.collectionsTab.activeTabIndex === activeIndex) {
            setSelectedTabHeaders(activeTabData.collectionsTab.collectionsHeaders)
        }

        setCurrentPage(1);
        setPage(1);

    }, [activeIndex])

    useEffect(() => {
        if (keyword != null) {
            const delayDebounceFn = setTimeout(() => {
                if (currentPage != 1) {
                    setCurrentPage(1);
                    setPage(1);
                } else {
                    getDocuments();
                }
            }, 250);

            return () => clearTimeout(delayDebounceFn);
        }
    }, [keyword]);

    return (
        <div>
            {loading === true ? (
                <CustomLoading />
            ) : (
                <div className="col-12 pr-0">
                    <div className="card p-1 m-0">
                        <DataTable
                            value={gridData} // Correct prop name here
                            onSort={onSort}
                            sortable
                            sortField={sortField}
                            responsiveLayout="scroll"
                            emptyMessage="No record available."
                            paginatorTemplate={PaginatorTemplate(
                                pagination.isFirstPage,
                                pagination.isLastPage,
                                currentPage,
                                pagination.totalPages,
                                pageSize,
                                page,
                                pagination.totalRecords,
                                pageInputTooltip,
                                setCurrentPage,
                                setPage,
                                setPageSize,
                                setPageInputTooltip
                            )}
                            rows={pageSize}
                            paginator
                            selectionMode="single"
                        >
                            {columnComponents}
                        </DataTable>
                    </div>
                </div>
            )}

            {openAttachmentLoading && <CustomLoading center />}
        </div>
    )
}

export default Body;
